import React from 'react';
import Axios from 'axios';

class SeasonsTable extends React.Component {

  constructor(props) {
		super(props);
		this.createSeasonRow = this.createSeasonRow.bind(this);
	}

	render() {
		//console.log('SeasonsTable: RENDER')
		return (
			<div className="table-responsive">
				<table className="table table-striped table-hover table-sm">
				<tbody>
					<tr>
						<th width='200px'>Saisons</th>
						<th width='200px'>ID</th>
						<th width='60px'>Active</th>
						<th width='100px'></th>
					</tr>
					{this.props.seasons.map(this.createSeasonRow)}
				</tbody>
				</table>
			</div>
		);
	}

	createSeasonRow(season, seasonIdx) {
		return (
			<tr key={season._id}>
				<td>{season.name}</td>
				<td>{season._id}</td>
				<td>{season.status}</td>
				<td><input name={"del." + seasonIdx} type="button" onClick={this.props.handleDeleteSeason} value="Supprimer"/></td>
			</tr>
		);
	}

}

export default SeasonsTable;